import React from 'react';
import { Text } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';

const Container = styled.div`
  margin-top: 1em;
`;

const StyledType = styled(Text)`
  a[href]:not([class]) {
    color: var(--text-bright-accent);
    font-weight: bold;
    text-decoration: underline;
  }
  padding-bottom: 1em;
  font-size: 12px;
`;

const LegalText = () => {
  const { traw } = useTranslation();

  return (
    <Container>
      <StyledType forwardedAs="p" variant="marginal" semanticColor="textSubdued">
        {traw('privacy_notice', { url: 'https://www.spotify.com/legal/privacy-policy/' })}
      </StyledType>
    </Container>
  );
};

export default LegalText;
